<template>
  <div class="container">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="card ">
        <div class="card-header">
          <i class="fa fa-pencil"></i>
          <strong>Evento</strong>
        </div>
        <div class="card-block">
          <form>
            <div class="row">
              <div class="form-group col-md-8" :class="{'has-danger': errors.has('nome') }">
                <label class="col-form-label">Nome</label>
                <input type="text" class="form-control" :disabled="this.$route.params.name !== undefined" name="nome"  v-validate="'required'" v-model="model.name">
                <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
              </div>
              <div class="form-group col-md-4">
                  <label class="col-form-label">Tipo de Fila</label>
                  <select class="form-control" v-model="model.queueType">
                      <option value="kinesis" selected>AWS-Kinesis</option>
                      <option value="rabbit-mq">Rabbit-MQ</option>
                  </select>
                </div>
            </div>
            <div class="row">
              <div class="form-group col-md-8" :class="{'has-danger': errors.has('nome amigável') }">
                <label class="col-form-label">Nome amigável</label>
                <input type="text" class="form-control" name="nome amigável" v-validate="'required'" v-model="model.friendlyName">
                <span v-show="errors.has('nome amigável')" class="form-control-feedback">{{ errors.first('nome amigável') }}</span>
              </div>
              <div class="form-group col-md-4" :class="{'has-danger': errors.has('channel') }">
                  <label class="col-form-label">Canal</label>
                  <select class="form-control" name="channel" v-model="model.channel" v-validate="'required'">
                    <option v-for="(item, index) in config.channels" :key="index" v-bind:value="item"> {{ item }} </option>
                  </select>
                </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4" :class="{'has-danger': errors.has('categoryType') }">
                <label class="col-form-label">Tipo de categoria</label>
                  <select class="form-control" name="categoryType" v-model="model.categoryType" v-validate="'required'">
                    <option v-for="(item, index) in config.categoryTypes" :key="index" v-bind:value="item"> {{ item }} </option>
                  </select>
              </div>
              <div class="form-group col-md-4" :class="{'has-danger': errors.has('subjectType') }">
                <label class="col-form-label">Tipo de assunto</label>
                  <select class="form-control" name="subjectType" v-model="model.subjectType" v-validate="'required'">
                    <option v-for="(item, index) in config.subjectTypes" :key="index" v-bind:value="item"> {{ item }} </option>
                  </select>
              </div>
              <div class="form-group col-md-4" :class="{'has-danger': errors.has('relevanceLevel') }">
                <label class="col-form-label">Relevância</label>
                <select class="form-control" name="relevanceLevel" v-model="model.relevanceLevel" v-validate="'required'">
                  <option value="high">alto</option>
                  <option value="medium">médio</option>
                  <option value="low">baixo</option>
                </select>
              </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6" :class="{'has-danger': errors.has('fila') }">
                  <label class="col-form-label">Fila</label>
                  <input type="text" class="form-control" name="fila" v-validate="'required'" v-model="model.queueName">
                  <span v-show="errors.has('fila')" class="form-control-feedback">{{ errors.first('fila') }}</span>
                </div>
                <div class="form-group col-md-6" :class="{'has-danger': errors.has('fila unknown') }">
                  <label class="col-form-label">Fila Unknown</label>
                  <input type="text" class="form-control" name="fila unknown" v-validate="'required'" v-model="model.unknownQueueName">
                  <span v-show="errors.has('fila unknown')" class="form-control-feedback">{{ errors.first('fila unknown') }}</span>
              </div>
            </div>
            <div class="form-group">
              <label for="inputUrl" class="col-form-label">Atributos</label>
              <div v-for="(item, index) in att">
                <div class="input-group">
                  <input type="text" class="form-control col-md-3" id="inputAttKey" placeholder="Chave" v-model="item.key">
                  <span class="input-group-addon">=</span>
                  <input type="text" class="form-control col-md-3" id="inputattValue" placeholder="Valor" v-model="item.value">
                  <button type="button" v-on:click="removeAtt(item)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                  <button type="button" v-on:click="newAtt()" :disabled="index !== (att.length - 1)" class="btn btn-sm btn-default"><i class="fa fa-plus"></i></button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6" :class="{'input': true, 'has-danger': errors.has('Tamanho do lote') }">
                <label class="col-form-label">Tamanho máximo do lote</label>
                <input type="number" class="form-control" name="Tamanho do lote" v-validate="'required'" v-model.number="model.maxBatchSize">
                <span v-show="errors.has('Tamanho do lote')" class="form-control-feedback">{{ errors.first('Tamanho do lote') }}</span>
              </div>
            </div>
            
            <label for="inputUrl" class="col-form-label">Schema</label>
            <vue-json-editor v-model="schemaJson" mode="code" :showBtns="false"></vue-json-editor>
          </form>
        </div>

        <div class="card-footer">
          <div class="pull-right">
            <router-link :to="'/shaw/events'" class="btn btn-sm">
              <i class="fa fa-chevron-left"></i> Cancelar
            </router-link>
            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="saveEvent">
              <i class="fa fa-save"></i> Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import axios from 'axios'
import vueJsonEditor from 'vue-json-editor'

export default {
  name: 'event',
  components: {
    vueJsonEditor
  },
  data() {
    return {
      model: {
        name: '',
        queueType: 'kinesis',
        queueName: '',
        unknownQueueName: '',
        schema: null,
        attributes: [],
        maxBatchSize: 30
      },
      config: {},
      schemaJson: {},
      att: [
        { key: '',
          value: ''
        }]
    }
  },
  created() {
    axios.get(process.env.SHAW_API_URL + 'config').then(response => {
      this.config = response.data
      if (this.$route.params.name !== undefined) {
        axios.get(process.env.SHAW_API_URL + 'configurations/' + this.$route.params.name).then(response => {
          this.model = response.data
          if (response.data.schema !== undefined) {
            this.schemaJson = JSON.parse(response.data.schema)
          }

          if (response.data.attributes !== undefined) {
            this.att = []
            for (var key in response.data.attributes) {
              this.att.push({
                key: key,
                value: response.data.attributes[key]
              })
            }
          }
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao carregar o template.')
        })
      }
    }).catch(err => {
      console.error(err)
      this.showError('Ops. Ocorreu um erro ao carregar as configurações de evento.')
    })
  },
  watch: {
    'model.attributes': function(newValue, oldValue) {
      if (this.att.length === 0) {
        this.newAtt()
      }
    }
  },
  methods: {
    newAtt: function () {
      this.att.push({
        key: '',
        value: ''
      })
    },
    removeAtt: function (att) {
      this.att = this.att.filter(function (obj) {
        return obj.key !== att.key
      })
    },
    saveEvent() {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        if (this.schemaJson !== {}) {
          this.model.schema = JSON.stringify(this.schemaJson)
        }
        let lstAttributes = {}
        this.att.forEach(function(obj) {
          if (obj.key !== undefined && obj.key !== '') {
            lstAttributes[obj.key] = obj.value
          }
        })
        this.model.attributes = lstAttributes

        if (this.$route.params.name !== undefined) {
          axios.put(process.env.SHAW_API_URL + 'configurations/' + this.$route.params.name, this.model)
          .then(response => {
            this.showSuccess('Evento alterado com sucesso')
            this.$router.push('/shaw')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar o evento.')
          })
        } else {
          axios.post(process.env.SHAW_API_URL + 'configurations', this.model)
          .then(response => {
            this.showSuccess('Evento criado com sucesso')
            this.$router.push('/shaw')
          }).catch(err => {
            console.error(err)
            if (err.response.status === 409) {
              this.showInfo('O Evento já existe')
            } else {
              this.showError('Ops. Ocorreu um erro ao salvar o evento.')
            }
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?25993782